<template>
  <div>
    <form method="post"
          data-vv-scope="crear"
    >
      <b-row style="justify-content: center; font-size:15pt; text-align:center">
        Seleccione el nivel de ubicación que desea crear y <br> asignele el nombre a mostrar en el árbol de ubicaciones.
      </b-row>
      <b-row class="mt-4"
             style="justify-content: center"
      >
        <b-col sm="4">
          <b-form-group>
            <label for="id_nivel">Nivel de Ubicación</label><br/>
            <el-select id="id_nivel"
                       name="id_nivel"
                       @change="setEnlazarUbicacion(nivelesActivos[selectedUbicacion.id])"
                       v-model="selectedUbicacion.id"
                       data-vv-as=" "
                       size="sm"
                       v-validate="'required'"
            >
              <el-option v-for="nivelActivo in nivelesActivos"
                         :label="nivelActivo.text"
                         :value="nivelActivo.value"
                         :key="nivelActivo.value"
              />
            </el-select>
            <span class="text-danger span-error small">
              {{ errors.first('crear.id_nivel') }}
            </span>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <label for="descripcion">Descripción Ubicación</label>
            <b-form-input id="descripcion"
                          size="sm"
                          type="text"
                          name="descripcion"
                          class="text-uppercase"
                          v-model="selectedUbicacion.descripcion"
                          data-vv-as=" "
                          v-validate="'required'"
            >
            </b-form-input>
            <span class="text-danger span-error small">
              {{ errors.first('crear.descripcion') }}
            </span>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group v-if="selectedUbicacion.nivel === 1">
            <label for="ubicacion_hija">Descripción Ubicación hija</label>
            <b-form-input id="ubicacion_hija"
                          size="sm"
                          type="text"
                          name="ubicacion_hija"
                          v-model="selectedUbicacion.ubicacion_hija"
                          data-vv-as=" "
                          v-validate="'required'"
            >
            </b-form-input>
            <span class="text-danger span-error small">
              {{ errors.first('crear.descripcion') }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
    <b-row>
      <b-col>
        <button class="btn btn-primary float-right"
                @click="nuevaUbicacion()"
        >
          Siguiente
        </button>
        <button class="btn btn-secondary float-right mr-2"
                @click="cancelar"
        >
          Cancelar
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {mapState, mapActions, mapMutations} from 'vuex';

export default {
  methods: {
    async verNivel() {
      this.setFiltroNivel();
      await this.listarNivel(this.$route.params.id);
    },
    async nuevaUbicacion() {
      this.$validator.validateAll('crear').then(async (result) => {
        if (result) {
          await this.verListaUbicaciones();
          if (this.ubicacionEmpresa.length === 0) {
            await this.crearUbicacion(this.$route.params.id);
            this.setIdParent(0);
            await this.arbolUbicacionesEmpresa();
            this.resetSelectedUbicacion();
            this.setModal(false);
          } else {
            await this.setPaso(1);
          }
        }
      });
    },
    async cancelar() {
      this.resetSelectedUbicacion();
      this.resetOptions();
      this.setModal(false);
    },
    ...mapActions('ubicacion', [
      'crearUbicacion',
      'listarNivel',
      'verListaUbicaciones',
      'listarNivelActivos',
      'crearUbicacionEmpresa',
      'arbolUbicacionesEmpresa'
    ]),
    ...mapMutations('ubicacion', [
      'setFiltro',
      'setUbicacionEmpresa',
      'setPaso',
      'setModal',
      'setEnlazarUbicacion',
      'resetSelectedUbicacion',
      'resetSelectedNivel',
      'setIdParent',
      'resetOptions'
    ]),
  },
  computed: {
    ...mapState('ubicacion', [
      'selectedUbicacion',
      'ubicaciones',
      'ubicacionEmpresa',
      'nivelesActivos',
      'id_ubicacion',
      'ubicacionAsig',
      'crearUbic',
      'modal',
      'errorUbic',
      'selectedNivel'
    ]),
  },
};
</script>
